import { get, filter, sortBy } from 'lodash';

import {
  POLICY_NOTE_START,
  POLICY_NOTE_SUCCESS,
  POLICY_NOTE_FAILED,
  PolicyNotesStore,
  PolicyNotesResponse,
  POLICY_NOTE_ADD_START,
  POLICY_NOTE_ADD_SUCCESS,
  POLICY_NOTE_ADD_FAILED
} from './types';

export const policyNotes = (
  state: PolicyNotesStore = {
    noteFetched: false,
    loading: false
  },
  action: {
    type: string;
    payload?: unknown;
  }
): PolicyNotesStore => {
  switch (action.type) {
    case POLICY_NOTE_START:
      return {
        ...state,
        noteFetched: false,
        noteError: null,
        loading: true
      };
    case POLICY_NOTE_SUCCESS: {
      const policyNumber = get(action.payload, 'policyNumber', '');
      let note = filter(state.note, n => n.policyNumber !== policyNumber);
      note.push(action.payload as PolicyNotesResponse);
      note = sortBy(note, ['policyNumber']);
      return {
        ...state,
        noteFetched: true,
        loading: false,
        note
      };
    }
    case POLICY_NOTE_FAILED:
      return { ...state, noteFetched: true, loading: false, noteError: action.payload };
    case POLICY_NOTE_ADD_START:
      return { ...state, noteFetched: false, loading: true, noteError: null };
    case POLICY_NOTE_ADD_SUCCESS:
      return {
        ...state,
        noteFetched: true,
        loading: false
      };
    case POLICY_NOTE_ADD_FAILED: {
      return {
        ...state,
        loading: false,
        noteFetched: true,
        noteError: action.payload
      };
    }
    default:
      return state;
  }
};
